import React from 'react';
import { useTranslation } from 'react-i18next';
import Hero from '../../components/Hero';
import PageIntro from '../../components/PageIntro';
import Quotes from '../../components/Quotes';

const Home = () => {
    const { t } = useTranslation();
    const tr = (key) => t(`homePage:${key}`);

    return (
        <div className="min-h-screen">
            <PageIntro title={tr('seoTitle')} description={tr('pageDescription')} />
            <Hero />
            <Quotes />
        </div>
    );
};

export default Home;
